export default {
  computed: {
    is004Path () {
      return window.location.pathname === '/lp/chat/004/'
    },
    is005Path () {
      return window.location.pathname === '/lp/chat/005/'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/PathMixin.js